import DataTranscribeQueuePaged from "../../WorkflowQueues/DataTranscriber/DataTranscriberQueuePaged";
import KeywordQueuePaged from "../../WorkflowQueues/Keywords/KeywordQueuePaged";
import DataTranscriberValidationQueuePaged from "../../WorkflowQueues/DataTranscriberValidation/DataTranscriberValidationQueuePaged";
import CheckersQueuePaged from "../../WorkflowQueues/Checkers/CheckersQueuePaged";
import DataEntryQueuePaged from "../../WorkflowQueues/DataEntry/DataEntryQueuePaged";
import MatchingQueuePaged from "../../WorkflowQueues/Matching/MatchingQueuePaged";
import * as React from "react";
import NotificationTemplateList from "../../NotificationTemplate/TemplateList";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import Layout from "../../Layout/Layout";
import QueuedNotifications from "../../NotificationQueue/QueuedNotifications";
import "../../../assets/scss/App.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "font-awesome/css/font-awesome.css";
import SentNotifications from "../../NotificationQueue/SentNotifications";
import NotificationTabContainer from "../../Notifications/NotificationTabContainer";
import ManageNotifications from "../../ManageNotifications/ManageNotifications";
import ManageFARs from "../../Forms/FARS/ManageFARs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuditLogViewer from "../../AuditLogs/presentation/AuditLogViewer";
import Login from "../../Login/LoginComponent";
import UserAdministrationController from "../../Administration/Users/UserAdministrationController";
import PrintPDF from "../../PrintPDF/PDFRenderer";
import RoleAdmin from "../../Administration/Roles/RoleManagementController";
import ReportChainEditor from "../../Administration/ReportChainEditor/ReportChainEditorController";
import AccessDenied from "./AccessDenied";
import LoginAadController from "../../LoginAAD/LoginAadController";
import FormAdmin from "../../Administration/FormIO/FormManagementController";
import FormFieldHistory from "../../Administration/FormIO/FieldHistory/FormFieldHistoryController";
import { ClearLocalLogin, LocalLogin } from "../../Login/LocalLogin";
import LookupTypes from "../../LookupValues/presentation/LookupTypes";
import WorkflowAdmin from "../../Workflow/WorkflowAdmin";
import AdvancedSearch from "../../AdvancedSearch/AdvancedSearch";
import DmvSearch from "../../DmvSearch/DmvSearch";
import WorkZoneSearch from "../../WorkZoneSearch/WorkZoneSearch";
import DuplicateSearch from "../../DuplicateSearch/DuplicateSearch";
import RedactedFields from "../../RedactedFields/RedactedFields";
import VendorTabContainer from "../../ThirdPartyVendors/VendorTabContainer";
import CreateNewVendor from "../../ThirdPartyVendors/AgencyVendorContract";
import VendorList from "../../ThirdPartyVendors/Vendor";
import Keywords from "../../WorkflowQueues/Keywords/Keyword";
import DataEntryQueue from "../../WorkflowQueues/DataEntry/DataEntryQueue";
import LocationQueue, {
  eLocationQueue
} from "../../WorkflowQueues/Location/controller/LocationQueueController";
import DataTranscriber from "../../WorkflowQueues/DataTranscriber/DataTranscriber";
import DataTranscriberValidation from "../../WorkflowQueues/DataTranscriberValidation/DataTranscriberValidation";
import { getWorkflowSteps } from "../../WorkflowQueues/redux-objects/actions";
import FARSQueue from "../../WorkflowQueues/FARS";
import ManagementQueue from "../../WorkflowQueues/Management";
import ManageReport from "../../WorkflowQueues/Management/presentation/ManageReport";
import LicensePlateLookupTool from "../../LicensePlateLookupTool/LicensePlateLookupTool";
import * as urls from "../../shared/urls";
import FormImporter from "../../Administration/FormIO/Components/Import";
import FormCreate from "../../Administration/FormIO/FormEdit";
import FlashlightSearch from "../../FlashlightSearch/FlashlightSearch";
import Merging from "../../WorkflowQueues/Matching/Merging";
import CheckerReview from "../../WorkflowQueues/Checkers/CheckerReview";
import Checking from "../../WorkflowQueues/Checkers/Checking";
import ExtractsAdmin from "../../Extracts/ExtractsAdmin";
import ImportExport from "../../ImportExport/ImportExport";
import StandardSummaryAdmin from "../../StandardSummary/StandardSummaryAdmin";
import PowerBiAdmin from "../../PowerBI/PowerBiAdmin";
import ViewPbiReport from "../../PowerBI/ViewReport";
import EditReport from "../../PowerBI/EditReport";
import CreateReport from "../../PowerBI/CreateReport";
import Dashboard from "../../Dashboard/Dashboard";
import CaseStudySearch from "./../../CaseStudySearch/controller/CaseStudyController";
import DataEntry from "../../WorkflowQueues/DataEntry/DataEntry";
import DriverReport from "../../WorkflowQueues/DriverReport/DriverReport";
import ViewTval from "../../shared/ViewTvalFormButton/ViewTVal";
import ViewTvalFormButton from "../../shared/ViewTvalFormButton/ViewTvalFormButton";
import DocumentViewer from "../../DocumentViewer/DocumentViewer";
import LocationEntryPopOutView from "../../WorkflowQueues/Location/presentation/LocationEntryPopOutView";
import { UserInfo } from "../../Login/common/defaults";
import { isGrantedAny, permissions } from "../../../services/permissionChecker";
import TestViewStandardSummary from "../../StandardSummary/TestViewSummary";
import GenericDataTranscriberForm from "../../Forms/GenericForm/GenericDataTranscriberForm";
import GenericDataTranscriberValidationForm from "../../Forms/GenericForm/GenericDataTranscriberValidationForm";
import GenericDataEntryForm from "../../Forms/GenericForm/GenericDataEntryForm";
import GenericDriverReportForm from "../../Forms/GenericForm/GenericDriverReportForm";
import GlobalSearch from "../../GlobalSearch/GlobalSearch";
import HealthDashboard from "../../HealthDashboard/HealthDashboard";

export enum Roles {
  Administrator = "Administrator",
  LocalAdmin = "Site Admin",
  Basic = "Basic",
  Location = "Location Group",
  Indexers = "Indexers",
  Checkers = "Checkers",
  FARS = "FARS",
  Management = "Management"
}

const initialState = {
  username: "",
  scrollTop: true
};

interface IAppControllerOwnProps {
  history: any;
}

interface IApplicationControllerPropsFromState {
  webServiceURL?: string;
  loggedIn?: boolean;
  formIOUrl: string;
  currentUser: UserInfo;
}

interface IApplicationControllerActionProps {
  getWorkflowSteps: (url: string) => void;
}

type IAppControllerProps = IAppControllerOwnProps &
  IApplicationControllerPropsFromState &
  IApplicationControllerActionProps;

// prettier-ignore
class AppController extends React.Component<IAppControllerProps, any> {
  public constructor(props: any) {
    super(props);
    this.state = initialState;
    this.loadAppData();
  }

  loadAppData = () => {
    // Load data for the application after successfully logging in
    this.props.getWorkflowSteps(this.props.webServiceURL + urls.GET_WORKFLOW_STEPS);
  }

  scrollToTop = () => {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.scrollToTop();
  }

  componentDidUpdate(prevProps: IAppControllerProps) {
    if (prevProps.history.location.pathname !== this.props.history.location.pathname) {
      this.scrollToTop();
    }
  }

  /**
   * a page mapped to its associated permission where key matches the route path (w/o preceding '/' & lowercase) and value is an array of associated
   * empty array means no permission is needed
  **/
  pagesToPermission = {
    'advancedsearch': [permissions.AdvancedSearch],
    'casestudysearch': [permissions.CaseStudySearch],
    'licenseplatelookuptool': [permissions.LicensePlateSearch],
    'reportsearch': [permissions.FlashlightSearchPrivate, permissions.FlashlightSearchPublic],
    'duplicatesearch': [permissions.DuplicateSearch],
    'globalsearch': [permissions.GlobalSearch],
    'dmvsearch': [permissions.DmvSearch],
    'workzonesearch': [permissions.WorkZoneSearch],
    'managefars': [permissions.EditFars],
    'fars': [permissions.EditFars],
    'keywordqueue': [permissions.EditKeywords],
    'keywords': [permissions.EditKeywords],
    'datatranscriberform': [permissions.DataTranscribe],
    'datatranscribervalidationform': [permissions.DataTranscribeValidation],
    'datatranscribervalidation': [permissions.DataTranscribeValidation],
    'genericdataentryform': [permissions.DataEntry],
    'driverreportform': [permissions.DriverReport],
    'genericdriverreportform': [permissions.DriverReport],
    'notifications': [permissions.Letters],
    'queuednotifications': [permissions.Letters],
    'sentnotifications': [permissions.Letters],
    'managenotifications': [permissions.Letters],
    'datatranscribequeue': [permissions.DataTranscribe],
    'datatranscriber': [permissions.DataTranscribe],
    'datatranscribervalidationqueue': [permissions.DataTranscribeValidation],
    'dataentryqueue': [permissions.DataEntry],
    'dataentryform': [permissions.DataEntry],
    'dataentryreview': [permissions.DataEntry],
    'locationmapping': [permissions.EditLocation],
    'locationreview': [permissions.Reviewer],
    'checkers': [permissions.CheckerReview],
    'checkerreview': [permissions.CheckerReview],
    'matchingqueue': [permissions.MatchingQueue],
    'managementqueue': [permissions.ManagementQueue],
    'auditlogs': [permissions.AuditLog],
    'notificationtemplates': [permissions.EditLetterTemplates],
    'lookuptypesadmin': [permissions.LookupTypesAdmin],
    'redactedfields': [permissions.RedactFields],
    'formadmin': [permissions.FormAdmin],
    'formfieldhistory': [permissions.FormAdmin],
    'printpdf': [permissions.PrintReportSample],
    'vendortabcontainer': [permissions.ManageVendors],
    'extractsadmin': [permissions.Extracts],
    'standardsummary': [permissions.StandardSummary],
    'roleadmin': [permissions.RoleAdmin],
    'reportchaineditor': [permissions.ReportChainEditor],
    'useradmin': [permissions.AddEditUser],
    'workflow': [permissions.ManageWorkflow],
    'powerbireports': [permissions.PowerBIViewReport, permissions.PowerBIViewAllReports],
    'viewreport': [permissions.PowerBIViewReport, permissions.PowerBIViewAllReports],
    'editreport': [permissions.PowerBIEditReport, permissions.PowerBIEditAllReports],
    'createreport': [permissions.PowerBICreateReport],
    'viewtval': [permissions.EditLocation, permissions.Reviewer],
    'documentviewer': [
      permissions.EditKeywords,
      permissions.DataTranscribe,
      permissions.DataTranscribeValidation,
      permissions.DataEntry,
      permissions.EditLocation,
      permissions.Reviewer,
      permissions.CheckerReview,
      permissions.MatchingQueue,
      permissions.ManagementQueue,
      permissions.FlashlightSearchPrivate,
      permissions.FlashlightSearchPublic,
      permissions.DmvSearch,
    ],
    'locationEntryPopOutView': [
      permissions.EditKeywords,
      permissions.DataTranscribe,
      permissions.DataTranscribeValidation,
      permissions.DataEntry,
      permissions.EditLocation,
      permissions.Reviewer,
      permissions.CheckerReview,
      permissions.MatchingQueue,
      permissions.ManagementQueue,
      permissions.FlashlightSearchPrivate,
      permissions.FlashlightSearchPublic,
      permissions.DmvSearch
    ],
    'standardsummaryviewer': [permissions.StandardSummary],
    'createnewvendor': [],
    'merging': [],
    'checking': [],
    'importform': [],
    'farsqueue': [],
    'createform': [],
    'managereport': [],
    'healthdashboard': [permissions.FormAdmin]
  }

  hasPermission() {
    const pageToAccess: string = this.props.history.location.pathname.toString().replace(/\//g, '');

    // Pages available to any Administrator (not tied to a granular permission).
    const adminOnlyPages: string[] = ['importexport'];
    if (adminOnlyPages.includes(pageToAccess.toLocaleLowerCase())) {
      return this.isAdministrator();
    }

    const permissions: string[] = this.pagesToPermission[pageToAccess.toLocaleLowerCase()];
    const user = this.props.currentUser;

    if (permissions === undefined) return false; // default to false when page doesn't have a permission

    return isGrantedAny(permissions, user);
  }

  // True once the authenticated user (and its roles/permissions) has finished
  // loading. Guards against a login race where loggedIn flips true before
  // currentUser is populated, which briefly failed every permission check and
  // rendered the AccessDenied catch-all on startup.
  isUserLoaded() {
    const user = this.props.currentUser;
    return !!(user && user.userRoles);
  }

  isAdministrator() {
    const user = this.props.currentUser;
    return !!(user && user.userRoles && user.userRoles.some(
      (item) => item.role.name == 'Administrator' || item.role.name == 'Local Admin'
    ));
  }

  render() {
    return (
      <React.Fragment>
        {this.props.loggedIn
          && this.props.history.location.pathname.toString().replace(/\//g, '') != "testss" && (
            <Layout>
              <Switch>
                <Route path='/' exact render={() => <Redirect to='/Dashboard' />} />
                <Route path='/LoginAAD' render={() => <Redirect to='/Dashboard' />} />
                <Route path='/Dashboard' component={Dashboard} />
                <Route path='/gobledeguk' component={ViewTvalFormButton} />
                {this.hasPermission() ? (
                  <>
                    <Route path='/AdvancedSearch' component={AdvancedSearch} />
                    <Route path='/QueuedNotifications' component={QueuedNotifications} />
                    <Route path='/SentNotifications' component={SentNotifications} />
                    <Route path='/Notifications' component={NotificationTabContainer} />
                    <Route path='/NotificationTemplates' component={NotificationTemplateList} />
                    <Route path='/ManageFARs' component={ManageFARs} />
                    <Route path='/Keywords' component={Keywords} />
                    <Route path='/AuditLogs' component={AuditLogViewer} />
                    <Route path='/HealthDashboard' component={HealthDashboard} />
                    <Route path='/ManageNotifications' component={ManageNotifications} />
                    <Route path='/UserAdmin' component={UserAdministrationController} />
                    <Route path='/RoleAdmin' component={RoleAdmin} />
                    <Route path='/ReportChainEditor' component={ReportChainEditor} />
                    <Route path='/LookupTypesAdmin' component={LookupTypes} />
                    <Route path='/Workflow' component={WorkflowAdmin} />
                    <Route path='/DataEntryReview' render={(routeProps) => (
                      <DataEntryQueue
                        {...routeProps}
                        key='1'
                        queueToLoad={DataEntryQueue.DataEntryReview}
                      />
                    )}
                    />
                    <Route path='/LocationMapping' render={(routeProps) => (
                      <LocationQueue
                        {...routeProps}
                        key='1'
                        queueToLoad={eLocationQueue.SpotMapping}
                      />
                    )}
                    />
                    <Route path='/LocationReview' render={(routeProps) => (
                      <LocationQueue
                        {...routeProps}
                        key='2'
                        queueToLoad={eLocationQueue.LocationReview}
                      />
                    )}
                    />
                    <Route path='/RedactedFields' component={RedactedFields} />
                    <Route path='/FormAdmin' component={FormAdmin} />
                    <Route path='/FormFieldHistory' component={FormFieldHistory} />
                    <Route path='/PrintPDF' component={PrintPDF} />
                    <Route path='/CaseStudySearch' component={CaseStudySearch} />
                    <Route path='/LicensePlateLookupTool' component={LicensePlateLookupTool} />
                    <Route path='/DmvSearch' component={DmvSearch} />
                    <Route path='/DuplicateSearch' component={DuplicateSearch} />
                    <Route path='/GlobalSearch' component={GlobalSearch} />
                    <Route path='/ReportSearch' component={FlashlightSearch} />
                    <Route path='/WorkZoneSearch' component={WorkZoneSearch} />
                    <Route path='/ExtractsAdmin' component={ExtractsAdmin} />
                    <Route path='/ImportExport' component={ImportExport} />
                    <Route path='/StandardSummary' component={StandardSummaryAdmin} />
                    <Route path='/PowerBiReports' component={PowerBiAdmin} />
                    <Route path='/ViewReport' component={ViewPbiReport} />
                    <Route path='/EditReport' component={EditReport} />
                    <Route path='/CreateReport' component={CreateReport} />
                    <Route path='/ViewTval' component={ViewTval} />
                    <Route path='/DocumentViewer' component={DocumentViewer} />
                    <Route path='/LocationEntryPopOutView' component={LocationEntryPopOutView} />
                    <Route path='/VendorTabContainer' component={VendorTabContainer} />
                    <Route path='/CreateNewVendor' component={CreateNewVendor} />
                    <Route path='/VendorList' component={VendorList} />
                    <Route path='/KeywordQueue' component={KeywordQueuePaged} />
                    <Route path='/DataTranscribeQueue' component={DataTranscribeQueuePaged} />
                    <Route path='/DataTranscriberValidationQueue' component={DataTranscriberValidationQueuePaged} />
                    <Route path='/DataTranscriber' component={DataTranscriber} />
                    <Route path='/DriverReport' component={DriverReport} />
                    <Route path='/DataTranscriberValidation' render={(routeProps) => (
                      <DataTranscriberValidation
                        data={
                          routeProps.location.state
                            ? routeProps.location.state.data
                            : ''
                        }
                        readOnly={
                          routeProps.location.state
                            ? routeProps.location.state.readOnly
                            : false
                        }
                        returnToAdvancedQuery={
                          routeProps.location.state
                            ? routeProps.location.state.returnToAdvancedQuery
                            : false
                        }
                        reportId={
                          routeProps.location.state
                            ? routeProps.location.state.reportId
                            : 0
                        }
                        history={routeProps.history}
                      />
                    )}
                    />
                    <Route path='/MatchingQueue' component={MatchingQueuePaged} />
                    <Route path='/Merging' component={Merging} />
                    <Route path='/Checkers' component={CheckersQueuePaged} />
                    <Route path='/CheckerReview' component={CheckerReview} />
                    <Route path='/Checking' component={Checking} />
                    <Route path='/DataEntryQueue' component={DataEntryQueuePaged} />
                    <Route path='/ImportForm' component={FormImporter} />
                    <Route path='/FARSQueue' component={FARSQueue} />
                    <Route path='/ManagementQueue' component={ManagementQueue} />
                    <Route path='/CreateForm' render={(routeProps) => (
                      <FormCreate
                        formURL={routeProps.location.state.formURL}
                        formJSON={routeProps.location.state.formJSON}
                        newForm={true}
                        history={routeProps.history}
                      />
                    )}
                    />
                    <Route path='/ManageReport' render={(routeProps) => (
                      <ManageReport
                        workflowItemStepId={routeProps.location.state.workflowItemStepId}
                      />
                    )}
                    />
                    <Route path='/DataEntryForm' render={(routeProps) => (
                      <DataEntry formUrl={this.props.formIOUrl + 'dataentryform'} />
                    )}
                    />
                    <Route path='/DataTranscriberForm' component={GenericDataTranscriberForm} />
                    <Route path='/DataTranscriberValidationForm' component={GenericDataTranscriberValidationForm} />
                    <Route path='/GenericDataEntryForm' component={GenericDataEntryForm} />
                    <Route path='/GenericDriverReportForm' component={GenericDriverReportForm} />
                    <Route path='/DriverReportForm' render={(routeProps) => (
                      <DriverReport
                        workflowItemStepId={
                          routeProps.location.state.workflowItemStepId
                        }
                        history={routeProps.history}
                      />
                    )}
                    />
                  </>) : (
                  <>
                    {this.isUserLoaded() && <Route component={AccessDenied} />}
                  </>)}
              </Switch>
            </Layout>
          )}

        <Switch>
          <Route path='/LocalLogin' component={LocalLogin} />
          <Route path='/ClearLocalLogin' component={ClearLocalLogin} />
          <Route path='/testss' component={TestViewStandardSummary} />
        </Switch>

        <LoginAadController />

        {!this.props.loggedIn &&
          this.props.history.location.pathname != '/LoginAAD' &&
          (this.props.history.location.pathname == '/LocalLogin' ||
            sessionStorage.getItem('isLocalLogin') === 'true' ||
            sessionStorage.getItem('signedOut') === 'true') && (
            <Switch>
              <Route path='/' exact component={Login} />
              <Redirect to='/' />
            </Switch>
          )}

        {!this.props.loggedIn &&
          (sessionStorage.getItem('signedOut') === null ||
            sessionStorage.getItem('signedOut') === 'false') &&
          this.props.history.location.pathname != '/LoginAAD' &&
          this.props.history.location.pathname != '/LocalLogin' &&
          sessionStorage.getItem('isLocalLogin') != 'true' && (
            <Switch>
              <Route path='/LoginAAD' exact component={LoginAadController} />
              <Redirect to='/LoginAAD' />
            </Switch>
          )}

        <ToastContainer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    loggedIn: reduxState.Application.loggedIn,
    webServiceURL: reduxState.Application.backendURL,
    loadingText: reduxState.Application.loadingText,
    formIOUrl: reduxState.Application.formIOUrl,
    currentUser: reduxState.Application.currentUser
  };
};

const mapDispatchToProps = {
  getWorkflowSteps
};

export default withRouter(
  connect<
    IApplicationControllerPropsFromState,
    IApplicationControllerActionProps
  >(
    mapStateToProps,
    mapDispatchToProps
  )(AppController)
);
